import ResizableScene from "../core/ResizableScene";

export default class HiddenObjectThumbnail extends Phaser.GameObjects.Container {
	id: number;
	texture: string;
	isFound = false;

	private background: Phaser.GameObjects.Image;
	private image: Phaser.GameObjects.Image;

	constructor(scene: ResizableScene, texture: string, id: number) {
		super(scene, 0, 0);
		this.id = id;
		this.texture = texture;

		this.setSize(150, 150);

		const background = (this.background = scene.add.image(0, 0, "objectBarEmpty"));
		background.setDisplaySize(160, 160);
		this.add(background);

		const image = (this.image = scene.add.image(0, 0, texture));
		this.add(image);

		scene.alignIn.Center(image, background);

		this.setScale(0);

		this.show();
	}

	show(): void {
		this.scene.tweens.add({
			targets: this,
			duration: 350,
			scale: 1,
			ease: Phaser.Math.Easing.Quadratic.Out,
		});
	}

	dismiss(): void {
		this.scene.tweens.add({
			targets: this,
			duration: 350,
			scale: 0,
			ease: Phaser.Math.Easing.Quadratic.Out,
			onComplete: () => this.destroy(),
		});
	}

	found(): void {
		const rays = this.scene.add.image(0, 0, "objectBarRays");
		const glow = this.scene.add.image(0, 0, "objectBarRaysGlow");
		this.add([rays, glow]);

		this.scene.add.tween({
			targets: [rays, glow],
			alpha: { from: 0, to: 0.8 },
			scale: { from: 0, to: 1 },
			duration: 500,
			loopDelay: 500,
			yoyo: true,
			ease: Phaser.Math.Easing.Quadratic.Out,
		});

		this.scene.add.tween({
			targets: rays,
			angle: 90,
			duration: 1500,
		});

		this.background = this.scene.add.image(0, 0, "objectBarFull");
		this.background.setDisplaySize(160, 160);
		this.add(this.background);

		this.image = this.scene.add.image(0, 0, this.texture.replace("1", "2"));
		this.add(this.image);

		this.createSparkles();
		this.isFound = true;
	}

	createSparkles(): void {
		const particleContainer = this.scene.add.container(0, 0);
		const particles: Phaser.GameObjects.Image[] = [];

		for (let i = 0; i < 18; i++) {
			const circle = new Phaser.Geom.Circle(0, 0, this.background.displayWidth / 2);
			const pos = circle.getRandomPoint();
			const particleTexture = "sparkle" + (1 + (i % 2));

			const particle = this.scene.add.image(pos.x, pos.y, particleTexture);
			particle.scale = 0;
			particles.push(particle);
			particleContainer.add(particle);

			this.scene.tweens.add({
				targets: particle,
				scale: { from: 0, to: 0.8 },
				alpha: { from: 0, to: 0.8 },
				duration: 400,
				yoyo: true,
				ease: Phaser.Math.Easing.Quadratic.InOut,
				delay: Phaser.Math.RND.between(0, 700),
			});
		}

		this.add(particleContainer);
	}
}
